import { render, staticRenderFns } from "./PqtProductTestEdit.vue?vue&type=template&id=39d85fe8"
import script from "./PqtProductTestEdit.vue?vue&type=script&lang=ts"
export * from "./PqtProductTestEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports